import React, { useState } from "react";
import { getAvatarUrl } from "@/utils/axios/userUtils";

interface AvatarDisplayProps {
  avatarUri?: string;
  size?: number;
  className?: string;
  alt?: string;
  fallbackText?: string;
}

/**
 * Composant pour afficher l'avatar d'un utilisateur avec une solution de secours
 * en cas d'erreur de chargement de l'image
 */
const AvatarDisplay: React.FC<AvatarDisplayProps> = ({
  avatarUri,
  size = 24,
  className = "",
  alt = "Avatar",
  fallbackText = "",
}) => {
  const [hasError, setHasError] = useState(false);

  // Génère un texte de secours à partir du nom/texte alternatif
  const generateFallbackText = () => {
    if (fallbackText) {
      return fallbackText
        .split(" ")
        .map((word) => word[0]?.toUpperCase() || "")
        .slice(0, 2)
        .join("");
    }
    return alt.substring(0, 2).toUpperCase();
  };
  const avatarUrl = getAvatarUrl(avatarUri);

  // Si l'URL est vide ou s'il y a eu une erreur, afficher un avatar de secours
  if (!avatarUrl || hasError) {
    return (
      <div
        className={`avatar placeholder ${className}`}
        style={{ width: `${size}px`, height: `${size}px` }}
      >
        <div className="bg-neutral-focus text-neutral-content rounded-full w-full h-full">
          <span>{generateFallbackText()}</span>
        </div>
      </div>
    );
  }

  // Sinon, afficher l'image avec une solution de secours en cas d'erreur
  return (
    <div
      className={`avatar ${className}`}
      style={{ width: `${size}px`, height: `${size}px` }}
    >
      <div className="rounded-full w-full h-full">
        <img src={avatarUrl} alt={alt} onError={() => setHasError(true)} />
      </div>
    </div>
  );
};

export default AvatarDisplay;
